import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';
import {
    Message,
    SlotSettings,
    StoppedDueToInsufficientFunds,
    StoppedDueToLossLimitReached,
    StoppedDueToSingleWinReached,
    StoppedDueToWinLimitReached
} from '@gongxigames/framework/slot';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {setAutoplaySpinsToZero} from '@gongxigames/framework/slotV2/ui/acts/utils';

export class AutoplayCheckNextSpinUIAct extends SyncUIActDecorator {
    public execute(): void {
        this.shouldAutoplayStopAndShowMessage();
        this.onExecuted?.();
    }

    protected shouldAutoplayStopAndShowMessage(): void {
        if (!slotStore.logic_canSpin.value) {
            this.showStopReasonMessage(StoppedDueToInsufficientFunds);

            return;
        }

        const autoplayOptions = slotStore.autoplayOptions.value;

        if(autoplayOptions?.autoplaySpins === 0) {
            this.stopAutoplay();

            return;
        }

        if (this.isLossLimit()) {
            this.showStopReasonMessage(StoppedDueToLossLimitReached);

            return;
        }

        if (this.isWinLimit()) {
            this.showStopReasonMessage(StoppedDueToWinLimitReached);

            return;
        }

        if (this.isSingleWinLimit()) {
            this.showStopReasonMessage(StoppedDueToSingleWinReached);

            return;
        }
    }

    private isSingleWinLimit(): boolean {
        const autoplayOptions = slotStore.autoplayOptions.value;
        const singleWin = autoplayOptions?.singleWin;

        return singleWin !== null
            && singleWin !== undefined
            && singleWin > 0
            && slotStore.logic_spinData.value
            && slotStore.logic_win.value >= singleWin * this.currencyFormatter.fractionSize;
    }

    private isWinLimit(): boolean {
        const autoplayOptions = slotStore.autoplayOptions.value;
        const winLimit = autoplayOptions?.winLimit;
        const autoplayBalance = slotStore.playerBalanceBeforeStartAutoplay.value;

        return winLimit != null
            && winLimit !== undefined
            && slotStore.logic_balance.value >= (winLimit * this.currencyFormatter.fractionSize) + autoplayBalance;
    }

    private isLossLimit(): boolean {
        const autoplayOptions = slotStore.autoplayOptions.value;
        const lossLimit = autoplayOptions?.lossLimit;
        const autoplayBalance = slotStore.playerBalanceBeforeStartAutoplay.value;

        return lossLimit != null && autoplayBalance - slotStore.logic_balance.value >= (lossLimit * this.currencyFormatter.fractionSize);
    }

    private showStopReasonMessage(message: Message): void {
        this.eventManager.emit('General.Message.SHOW', message);
        this.stopAutoplay();
    }

    protected stopAutoplay(): void {
        setAutoplaySpinsToZero();
        slotStore.batchUpdate({
            isAutoplay: false
        });
        (this.settings as SlotSettings).set('autoplayMode', false);
        this.eventManager.emit('Autoplay.STOPPED');
        this.emitter.emit('Autoplay.STOPPED');
        this.emitter.emit('UI.disableSpinAutoMode');
    }

    getName(): string {
        return 'AutoplayCheckNextSpinUIAct';
    }
}